import { tracked } from '@glimmer/tracking';

import FilterSortGoalMy from 'webapp/models-custom/filter-sort/goal-my';

export default class FilterSortGoalMyInList extends FilterSortGoalMy {
	@tracked override viewId = 'table';
	override itemDomSelector = '.table-row:not(.empty)';
}
